// @flow

import React from 'react';
import type { Node } from 'react';
import { Box } from '@leasen_nl/listo/src/components/grid';

type ColumnProps = {|
  children: Node,
  width?: number | [any, any, any, any, any],
|};

// @todo this component should be properly implemented in Listo
// see https://justlease.atlassian.net/browse/LISTO-294
const Column = ({ children, ...boxProps }: ColumnProps) => (
  <Box px={2} {...boxProps}>{children}</Box>
);

Column.defaultProps = {
  width: 0,
};

export default Column;
